import { render, staticRenderFns } from "./JaPrivacyPolicy.vue?vue&type=template&id=671d1f9e&scoped=true"
import script from "./JaPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./JaPrivacyPolicy.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "671d1f9e",
  null
  ,true
)

export default component.exports